import { render, staticRenderFns } from "./imgView.vue?vue&type=template&id=499aef4e&scoped=true"
import script from "./imgView.vue?vue&type=script&lang=js"
export * from "./imgView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499aef4e",
  null
  
)

export default component.exports